export default __webpack_public_path__ + "static/media/spotify.659f040d.png";